import apiHandler from "../../../../api/core/apiHandler";

const receivableApi = apiHandler("receivables");

export default receivableApi;